import { render, staticRenderFns } from "./SpecialsBlock.vue?vue&type=template&id=23e4e7fa&scoped=true&"
import script from "./SpecialsBlock.vue?vue&type=script&lang=js&"
export * from "./SpecialsBlock.vue?vue&type=script&lang=js&"
import style0 from "./SpecialsBlock.vue?vue&type=style&index=0&id=23e4e7fa&lang=scss&"
import style1 from "./SpecialsBlock.vue?vue&type=style&index=1&id=23e4e7fa&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23e4e7fa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('23e4e7fa')) {
      api.createRecord('23e4e7fa', component.options)
    } else {
      api.reload('23e4e7fa', component.options)
    }
    module.hot.accept("./SpecialsBlock.vue?vue&type=template&id=23e4e7fa&scoped=true&", function () {
      api.rerender('23e4e7fa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/blocks/SpecialsBlock.vue"
export default component.exports